export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_PENDING =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_PENDING'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_FULFILLED =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_FULFILLED'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_REJECTED =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_LOAD_REJECTED'

export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_PENDING =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_PENDING'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_FULFILLED =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_FULFILLED'
export const IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_REJECTED =
  'IS_MISSING_PUNCH_DEDUCTION_APPLICABLE_UPDATE_REJECTED'

export const MISSING_PUNCH_CALCULATION_LOAD = 'MISSING_PUNCH_CALCULATION_LOAD'
export const MISSING_PUNCH_CALCULATION_LOAD_PENDING = 'MISSING_PUNCH_CALCULATION_LOAD_PENDING'
export const MISSING_PUNCH_CALCULATION_LOAD_FULFILLED = 'MISSING_PUNCH_CALCULATION_LOAD_FULFILLED'
export const MISSING_PUNCH_CALCULATION_LOAD_REJECTED = 'MISSING_PUNCH_CALCULATION_LOAD_REJECTED'

export const MISSING_PUNCH_CALCULATION_UPDATE = 'MISSING_PUNCH_CALCULATION_UPDATE'
export const MISSING_PUNCH_CALCULATION_UPDATE_PENDING = 'MISSING_PUNCH_CALCULATION_UPDATE_PENDING'
export const MISSING_PUNCH_CALCULATION_UPDATE_FULFILLED =
  'MISSING_PUNCH_CALCULATION_UPDATE_FULFILLED'
export const MISSING_PUNCH_CALCULATION_UPDATE_REJECTED = 'MISSING_PUNCH_CALCULATION_UPDATE_REJECTED'
